import { render, staticRenderFns } from "./InsuranceCompanyTable.vue?vue&type=template&id=4fdecb76&"
import script from "./InsuranceCompanyTable.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports